export default "__VITE_ASSET__DaYHxyWv__"